export const DEFAULT_SKIN = 'light';
//# sourceMappingURL=SkeletonGroup.constants.js.map